import { TContent } from "."

const privacyTerms: TContent[] = [
  {
    type: "documentTitle",
    content: "Política de privacidade",
  },
  {
    type: "text",
    content: `Seu direito de privacidade é muito importante para nós! Nossa política visa proporcionar ao usuário o melhor aproveitamento dos nossos serviços, com segurança e respeito às suas informações.`,
  },
  {
    type: "title",
    content: "USUÁRIOS",
  },
  {
    type: "text",
    content: `São aqueles que acessam e utilizam o Sistema CONDHELP, disponível no site www.condhelp.com.`,
  },
  {
    type: "title",
    content: "A CONDHELP",
  },
  {
    type: "text",
    content: `CONDHELP SOLUÇÕES LTDA é uma empresa de tecnologia sediada em São José/SC, responsável pelo Sistema CONDHELP.`,
  },
  {
    type: "title",
    content: "OBJETIVOS",
  },
  {
    type: "text",
    content: `Esclarecer como os dados fornecidos são utilizados, armazenados e compartilhados. O uso do sistema implica concordância com a política de privacidade.`,
  },
  {
    type: "title",
    content: "COLETA DE DADOS",
  },
  {
    type: "text",
    content: `Coletamos dados pessoais, bancários, de localização, dispositivos, entre outros. Alguns dados são compartilhados com terceiros para serviços financeiros, mas não armazenados pela CONDHELP.`,
  },
  {
    type: "title",
    content: "USO DE DADOS",
  },
  {
    type: "text",
    content: `Os dados são usados para autenticação, prestação de serviços, suporte, melhorias no sistema, marketing, prevenção de fraudes e cumprimento de obrigações legais.`,
  },
  {
    type: "title",
    content: "CONSENTIMENTO",
  },
  {
    type: "text",
    content: `O USUÁRIO fornece consentimento individual para uso dos dados. A recusa pode limitar funcionalidades. A CONDHELP não garante segurança absoluta, mas adota medidas de proteção.`,
  },
  {
    type: "title",
    content: "REVISÃO E REVOGAÇÃO DE CONSENTIMENTO",
  },
  {
    type: "text",
    content: `O USUÁRIO pode revisar ou revogar o consentimento a qualquer momento, por e-mail. A revogação pode limitar o acesso a alguns serviços.`,
  },
  {
    type: "title",
    content: "COOKIES E TECNOLOGIAS",
  },
  {
    type: "text",
    content: `São utilizados cookies, pixel tags e web beacons para melhorar a experiência, entender o comportamento dos usuários e personalizar serviços. O uso pode ser desativado nas configurações do navegador.`,
  },
  {
    type: "title",
    content: "PROTEÇÃO DE DADOS",
  },
  {
    type: "text",
    content: `Os dados são criptografados durante a transmissão e armazenados com segurança em nuvem e instalações físicas restritas.`,
  },
  {
    type: "title",
    content: "ACESSO E RETENÇÃO DE INFORMAÇÕES",
  },
  {
    type: "text",
    content: `O USUÁRIO pode acessar e alterar seus dados. Após o fim do contrato, os dados serão excluídos ou anonimizados, salvo exigência legal.`,
  },
  {
    type: "title",
    content: "PORTABILIDADE DE DADOS",
  },
  {
    type: "text",
    content: `A portabilidade dos dados pode ser solicitada por e-mail, e será realizada em até 15 dias úteis, em formato estruturado e de fácil leitura.`,
  },
  {
    type: "title",
    content: "ATUALIZAÇÕES DA POLÍTICA DE PRIVACIDADE",
  },
  {
    type: "text",
    content: `A CONDHELP pode alterar esta política a qualquer momento. O uso contínuo do sistema implica aceitação das condições atualizadas.`,
  },
  {
    type: "title",
    content: "LEI APLICÁVEL",
  },
  {
    type: "text",
    content: `Regida pelas leis da República Federativa do Brasil. Foro competente: Comarca de São José/SC.`,
  },
  {
    type: "title",
    content: "SUPORTE",
  },
  {
    type: "text",
    content: `Dúvidas podem ser esclarecidas via e-mail suporte@condhelp.com. Os dados fornecidos no contato são descartados automaticamente após o atendimento.`,
  },
]

export default privacyTerms
